import * as React from "react";
import { cn } from "../../lib/utils";

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "block font-display text-label font-semibold uppercase tracking-label text-gray-mid",
        "mb-[6px]",
        className
      )}
      {...props}
    >
      {children}
      {required && (
        <span className="text-gold ml-1" aria-hidden>
          *
        </span>
      )}
    </label>
  )
);
Label.displayName = "Label";
